import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../store";
import { setSidebarCollapsed } from "../store/ui.slice";

/**
 * Custom hook to manage sidebar collapsed state with Redux persistence
 * @returns [collapsed, setCollapsed] tuple
 */
export const useSidebarCollapsed = () => {
  const dispatch = useDispatch();
  const collapsed = useSelector(
    (state: RootState) => state.ui.sidebarCollapsed
  );

  const setCollapsed = (value: boolean) => {
    dispatch(setSidebarCollapsed(value));
  };

  return [collapsed, setCollapsed] as const;
};
